(function () {
  // Prevent flicker: Show images matching selected variant immediately, then let StarApps refine
  const productLayout = document.querySelector('.product-header_layout');
  if (!productLayout) return;

  const selectedVariantId = productLayout.getAttribute('data-selected-variant');

  // Function to show images matching the selected variant initially
  function showInitialImages() {
    if (!selectedVariantId) {
      // No variant selected, show all images
      productLayout.classList.add('starapps-ready');
      return;
    }

    const gallerySlides = document.querySelectorAll('.swiper-slide.is-product-gallery');
    const thumbnailSlides = document.querySelectorAll('.swiper-slide.is-product-thumbnail');

    // Show images matching the selected variant immediately to prevent flicker
    gallerySlides.forEach((slide) => {
      const variantIds = slide.getAttribute('data-variant-ids');
      // Show if it matches selected variant OR if variant_ids is empty (image applies to all variants)
      if (!variantIds || variantIds === '' || variantIds.includes(selectedVariantId)) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
      }
    });

    thumbnailSlides.forEach((slide) => {
      const variantIds = slide.getAttribute('data-variant-ids');
      if (!variantIds || variantIds === '' || variantIds.includes(selectedVariantId)) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
      }
    });

    // Mark as ready after a short delay to let StarApps take over
    setTimeout(function () {
      productLayout.classList.add('starapps-ready');

      // Let StarApps handle visibility from now on
      // Remove inline styles so StarApps can control them
      gallerySlides.forEach((slide) => {
        slide.style.opacity = '';
        slide.style.visibility = '';
      });
      thumbnailSlides.forEach((slide) => {
        slide.style.opacity = '';
        slide.style.visibility = '';
      });
    }, 150);
  }

  // Run immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showInitialImages);
  } else {
    showInitialImages();
  }

  // Preload all thumbnail images for instant display
  const thumbnailImages = document.querySelectorAll('.product_thumbnail-image');
  thumbnailImages.forEach((img) => {
    if (img.src && !img.complete) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = img.src;
      link.setAttribute('fetchpriority', 'low');
      document.head.appendChild(link);
    }
  });
})();

// ===================================
// VIDEO & 3D MODEL GALLERY HANDLER
// ===================================
(function () {
  'use strict';

  let currentActiveSlide = null;
  let gallerySwiper = null;
  let initAttempts = 0;
  const MAX_INIT_ATTEMPTS = 50; // 5 seconds max wait
  const INIT_RETRY_DELAY = 100; // Check every 100ms

  /**
   * Stop all media in a slide
   */
  function stopMediaInSlide(slide) {
    if (!slide) return;

    const mediaType = slide.getAttribute('data-media-type');

    // Pause videos
    if (mediaType === 'video' || mediaType === 'external_video') {
      const video = slide.querySelector('video, iframe');
      if (video) {
        if (video.tagName === 'VIDEO') {
          video.pause();
          video.currentTime = 0;
        } else if (video.tagName === 'IFRAME') {
          // For external videos (YouTube, Vimeo), try to pause via postMessage
          try {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          } catch (e) {
            console.log('Could not pause external video:', e);
          }
        }
      }
    }

    // Pause 3D model auto-rotation (model-viewer continues to allow manual interaction)
    if (mediaType === 'model') {
      const modelViewer = slide.querySelector('model-viewer');
      if (modelViewer) {
        modelViewer.pause();
      }
    }
  }

  /**
   * Start media in a slide
   */
  function startMediaInSlide(slide) {
    if (!slide) return;

    const mediaType = slide.getAttribute('data-media-type');

    // Autoplay videos (muted)
    if (mediaType === 'video' || mediaType === 'external_video') {
      const video = slide.querySelector('video');
      if (video) {
        video.muted = true;
        video.play().catch((err) => {
          console.log('Video autoplay prevented:', err);
        });
      }
      // Note: External videos (iframe) typically handle autoplay via their embed parameters
    }

    // Play/resume 3D model auto-rotation
    if (mediaType === 'model') {
      const modelViewer = slide.querySelector('model-viewer');
      if (modelViewer) {
        modelViewer.play();
      }
    }
  }

  /**
   * Handle slide change
   */
  function handleSlideChange(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];

    // Stop media in previous slide
    if (currentActiveSlide && currentActiveSlide !== activeSlide) {
      stopMediaInSlide(currentActiveSlide);
    }

    // Start media in new active slide
    if (activeSlide) {
      startMediaInSlide(activeSlide);
      currentActiveSlide = activeSlide;
    }
  }

  /**
   * Initialize media handlers
   */
  function initMediaHandlers() {
    // Find the gallery swiper instance
    // Swiper typically attaches instance to the DOM element
    const swiperContainer = document.querySelector('.swiper.is-product-gallery');
    
    if (!swiperContainer) {
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        initAttempts++;
        setTimeout(initMediaHandlers, INIT_RETRY_DELAY);
      } else {
        console.log('Product gallery swiper not found after maximum attempts');
      }
      return;
    }

    // Check if swiper instance exists
    if (swiperContainer.swiper) {
      gallerySwiper = swiperContainer.swiper;
      
      // Add slide change listener
      gallerySwiper.on('slideChange', function() {
        handleSlideChange(gallerySwiper);
      });

      // Initialize first slide
      const firstSlide = gallerySwiper.slides[gallerySwiper.activeIndex];
      if (firstSlide) {
        currentActiveSlide = firstSlide;
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          startMediaInSlide(firstSlide);
        }, 300);
      }

      console.log('✅ Product gallery media handlers initialized');
    } else {
      // Swiper not initialized yet, retry
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        initAttempts++;
        setTimeout(initMediaHandlers, INIT_RETRY_DELAY);
      } else {
        console.log('Swiper instance not found after maximum attempts');
      }
    }
  }

  /**
   * Handle user interaction with videos (unmute on click)
   */
  function setupVideoInteractions() {
    document.addEventListener('click', function(e) {
      const video = e.target.closest('video.product-header_video');
      if (video) {
        // Toggle mute on video click
        video.muted = !video.muted;
      }
    });
  }

  /**
   * Setup model-viewer interactions
   */
  function setupModelViewerInteractions() {
    const modelViewers = document.querySelectorAll('model-viewer.product-header_model');
    
    modelViewers.forEach((modelViewer) => {
      // Pause auto-rotate when user starts interacting
      modelViewer.addEventListener('camera-change', function(event) {
        if (event.detail.source === 'user-interaction') {
          // User is manually rotating, pause auto-rotate temporarily
          modelViewer.removeAttribute('auto-rotate');
          
          // Resume auto-rotate after 3 seconds of no interaction
          clearTimeout(modelViewer._autoRotateTimeout);
          modelViewer._autoRotateTimeout = setTimeout(() => {
            if (modelViewer.closest('.swiper-slide-active')) {
              modelViewer.setAttribute('auto-rotate', '');
            }
          }, 3000);
        }
      });

      // Log when model is loaded
      modelViewer.addEventListener('load', function() {
        console.log('✅ 3D Model loaded successfully');
      });

      // Handle model loading errors
      modelViewer.addEventListener('error', function(e) {
        console.error('❌ 3D Model loading error:', e);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMediaHandlers();
      setupVideoInteractions();
      setupModelViewerInteractions();
    });
  } else {
    initMediaHandlers();
    setupVideoInteractions();
    setupModelViewerInteractions();
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    const allSlides = document.querySelectorAll('.swiper-slide.is-product-gallery');
    allSlides.forEach(stopMediaInSlide);
  });
})();

// ===================================
// HERO TITLE MANUAL BALANCE (Datch 2026-09-08)
// -----------------------------------
// CSS `text-wrap: balance` on h1.product-title (assets/custom.css) mis-measures
// when the title contains an atomic `white-space:nowrap` span - specifically the
// <span style="white-space:nowrap">L-Shaped</span> wrapper (blocks/product-name.liquid)
// that stops "L-Shaped" from breaking at its hyphen. Confirmed by direct A/B: the
// SAME title at the SAME width balances correctly with the span removed, and badly
// (one short line, one long line) with it present - a real browser limitation, not
// a value to tune. word-break:keep-all and display:inline-block on the span were
// both tried and do not fix it (keep-all has no effect on Latin hyphens at all;
// inline-block breaks the line count entirely). Titles WITHOUT the span balance
// correctly under native CSS and are left alone; only titles containing the span
// are balanced here, manually, by simulating the same "narrowest width that still
// fits in N lines" idea `text-wrap:balance` itself uses, but treating the span as
// one indivisible token ourselves instead of relying on the engine to.
// ===================================
(function () {
  var titleEl = document.querySelector('h1.product-title');
  if (!titleEl) return;

  var originalHTML = null;
  var resizeTimer = null;

  function hasAtomicSpan(html) {
    return /<span/i.test(html);
  }

  function tokenize(html) {
    var container = document.createElement('div');
    container.innerHTML = html;
    var tokens = [];
    container.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent.split(/\s+/).forEach(function (w) {
          if (w) tokens.push({ text: w });
        });
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        tokens.push({ html: node.outerHTML });
      }
    });
    return tokens;
  }

  // Renders every token on one hidden nowrap line (in the title's own font) and
  // reads each one's real width, plus one space's width, so the balance search
  // below works from actual measured pixels, not estimates.
  function measureTokens(tokens) {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:-9999px;';
    var cs = getComputedStyle(titleEl);
    ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'textTransform'].forEach(function (p) {
      probe.style[p] = cs[p];
    });
    document.body.appendChild(probe);

    var spans = tokens.map(function (t) {
      var span = document.createElement('span');
      if (t.html) span.innerHTML = t.html; else span.textContent = t.text;
      probe.appendChild(span);
      return span;
    });
    var spaceProbe = document.createElement('span');
    spaceProbe.textContent = ' ';
    probe.appendChild(spaceProbe);

    var widths = spans.map(function (span) { return span.getBoundingClientRect().width; });
    var spaceWidth = spaceProbe.getBoundingClientRect().width;
    document.body.removeChild(probe);
    return { widths: widths, spaceWidth: spaceWidth };
  }

  function greedyLineCount(widths, spaceWidth, containerWidth) {
    var lines = 1, cur = 0;
    widths.forEach(function (w) {
      var add = (cur === 0 ? w : spaceWidth + w);
      if (cur + add > containerWidth && cur > 0) {
        lines++;
        cur = w;
      } else {
        cur += add;
      }
    });
    return lines;
  }

  // All valid ways to cut k tokens (in order) into exactly n contiguous, non-empty
  // lines is a choice of (n-1) break-gaps out of the (k-1) gaps between tokens.
  // Titles are short (a handful of words), so brute-forcing every composition and
  // keeping the one with the smallest longest line - tie-broken by lowest variance
  // across line widths, i.e. the most EVEN split, matching what was asked - is
  // cheap and exact. No binary search needed at this scale.
  function combinations(poolSize, count) {
    var results = [];
    function rec(start, chosen) {
      if (chosen.length === count) { results.push(chosen.slice()); return; }
      var remaining = count - chosen.length;
      for (var i = start; i <= poolSize - remaining; i++) {
        chosen.push(i);
        rec(i + 1, chosen);
        chosen.pop();
      }
    }
    rec(0, []);
    return results;
  }

  function bestComposition(widths, spaceWidth, n) {
    var k = widths.length;
    if (n <= 1) return [0, k];
    function lineWidth(start, endInclusive) {
      var w = 0;
      for (var i = start; i <= endInclusive; i++) {
        w += widths[i];
        if (i > start) w += spaceWidth;
      }
      return w;
    }
    var gapCombos = combinations(k - 1, n - 1); // gap i = break between token i and i+1
    var best = null, bestMax = Infinity, bestVariance = Infinity;
    gapCombos.forEach(function (gaps) {
      var bounds = [0].concat(gaps.map(function (g) { return g + 1; })).concat([k]);
      var lineWidths = [];
      for (var i = 0; i < bounds.length - 1; i++) {
        lineWidths.push(lineWidth(bounds[i], bounds[i + 1] - 1));
      }
      var max = Math.max.apply(null, lineWidths);
      var mean = lineWidths.reduce(function (a, b) { return a + b; }, 0) / lineWidths.length;
      var variance = lineWidths.reduce(function (a, b) { return a + (b - mean) * (b - mean); }, 0);
      if (max < bestMax - 0.5 || (Math.abs(max - bestMax) <= 0.5 && variance < bestVariance)) {
        bestMax = max;
        bestVariance = variance;
        best = bounds;
      }
    });
    return best;
  }

  function applyBalance() {
    if (originalHTML === null) originalHTML = titleEl.innerHTML;
    if (!hasAtomicSpan(originalHTML)) return; // native CSS text-wrap:balance already handles these correctly

    var tokens = tokenize(originalHTML);
    if (tokens.length < 2) return;

    var m = measureTokens(tokens);
    var containerWidth = titleEl.getBoundingClientRect().width;
    if (!containerWidth) return; // hidden/not yet laid out - try again next trigger
    var naturalWidth = m.widths.reduce(function (a, b) { return a + b; }, 0) + m.spaceWidth * (tokens.length - 1);

    if (naturalWidth <= containerWidth) {
      titleEl.innerHTML = originalHTML; // fits on one line at this width - no breaks needed
      return;
    }

    var n = greedyLineCount(m.widths, m.spaceWidth, containerWidth);
    var bounds = bestComposition(m.widths, m.spaceWidth, n);
    if (!bounds) { titleEl.innerHTML = originalHTML; return; }

    var lines = [];
    for (var i = 0; i < bounds.length - 1; i++) {
      var parts = tokens.slice(bounds[i], bounds[i + 1]).map(function (t) { return t.html || t.text; });
      lines.push(parts.join(' '));
    }
    // A literal space before <br> (not just <br> alone): <br> contributes nothing to
    // .textContent, so joining lines with bare <br> would leave "L-Shaped" and "Executive"
    // concatenated with no separator for anything reading raw textContent instead of
    // rendered text - invisible on screen, but a real defect for equivalence with the
    // original text. The trailing space is not rendered as visible extra space at a
    // forced line break.
    titleEl.innerHTML = lines.join(' <br>');
  }

  function run() {
    requestAnimationFrame(applyBalance);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(run);
  } else {
    run();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });
})();

// ===================================
// ATC BUTTON PRICE MIRROR, non-customizable products only (Datch 2026-09-08)
// -----------------------------------
// The interpunct + current-selection price on Add to Cart used to be
// Prod_Customizable-only, driven by agcf.js's updateAtcPrice(). agcf.js itself stays
// tag-gated (blocks/add-to-cart.liquid ~940: "custom finishing is offered ONLY on
// customizable products" - a deliberate ruling after 118 untagged products were
// exposed) so it is never loaded here. blocks/add-to-cart.liquid now renders the same
// stack markup on every PDP regardless, pre-filled server-side with the initial
// variant's price; this keeps that price in sync afterward for products where
// agcf.js never boots, exactly the same "silent stale price" class of bug fixed
// for the hero price earlier (agcf.js:7438-7448) - same technique, different target.
// ===================================
(function () {
  var btn = document.getElementById('add-to-cart-btn');
  if (!btn || btn.hasAttribute('data-agcf-atc-btn')) return; // customizable - agcf.js already owns this
  var sub = btn.querySelector('[data-agcf-atc-sub]');
  var mainEl = document.getElementById('product-main-price');
  if (!sub || !mainEl || !window.MutationObserver) return;

  function sync() {
    var txt = (mainEl.textContent || '').trim();
    if (txt && sub.textContent !== txt) sub.textContent = txt;
  }

  new MutationObserver(sync).observe(mainEl, { childList: true, characterData: true, subtree: true });
})();

